// Toggle claro/oscuro. La inicialización del tema (leer localStorage +
// prefers-color-scheme + aplicar la class `dark` al <html>) vive en un
// script inline en `index.html` que corre ANTES de que React monte —
// evita el FOUC (flash of unstyled content) que había con la versión
// previa de este componente, donde el initial useState(false) no
// matcheaba la class del DOM y había un flash entre 1er render y
// useEffect.
//
// Sprint 3 fix: el toggle ya no llama useEffect en mount. Deriva el
// state inicial de la class del DOM (que el script inline dejó bien) y
// solo maneja el click del user, siempre aplicando/removiendo la class
// explícitamente + persistiendo en localStorage.

import { Moon, Sun } from 'lucide-react';
import { useState } from 'react';

export function DarkModeToggle() {
  // Initial state deriva de lo que el script inline dejó en el DOM.
  // Sin useEffect ni fallback = 0 desync entre state y class aplicada.
  const [isDark, setIsDark] = useState(() => {
    if (typeof document === 'undefined') return false;
    return document.documentElement.classList.contains('dark');
  });

  const toggle = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);
    // Path bidireccional explícito — sin el bug pre-fix de agregar la
    // class sin removerla en el path opuesto.
    if (newIsDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  return (
    <button
      onClick={toggle}
      className="p-2 rounded-lg hover:bg-muted transition-all duration-200 ease-out"
      aria-label="Toggle dark mode"
    >
      {isDark ? (
        <Sun className="w-5 h-5" strokeWidth={1.5} />
      ) : (
        <Moon className="w-5 h-5" strokeWidth={1.5} />
      )}
    </button>
  );
}
